import { takeLatest, put, call } from 'redux-saga/effects';
import { CREATE_NEW_USER } from './actionTypes';
import clientConfig from '../../../parameters/client/config';
import NotificationsApi from '../../sdk/notifications/email/ApiNotifications';
import { createNewUserSuccess, createNewUserFailed } from './actions';
import { setUserCredentials } from '~/NotificationsManager/email/Authentication/actions';
import messages from '~/Alerts/permissionsEmailBanner/components/BannerForm/messages';
import { closeEmailChannelCapture } from '~/NotificationsManager/settings/actions';

const defaultNotificationsApi = new NotificationsApi(clientConfig.notificationApi);

export default function sagasModule(notificationsApi = defaultNotificationsApi) {
  function* createNewUser({ payload }) {
    const { email, countryCode, verticalId } = payload;

    const data = {
      email,
      countryCode,
      verticalId,
    };

    try {
      const result = yield call([notificationsApi, notificationsApi.createUser], data);
      const { token } = result;

      yield put(setUserCredentials(email, token));
      yield put(createNewUserSuccess());
      yield put(closeEmailChannelCapture());
    } catch (error) {
      if (error.status === 409) {
        yield put(createNewUserFailed(messages.emailUserAlreadyExists));
      } else {
        yield put(createNewUserFailed(messages.emailError));
      }
    }
  }
  function* emailSagas() {
    yield takeLatest(CREATE_NEW_USER, createNewUser);
  }

  return {
    createNewUser,
    emailSagas,
  };
}



// WEBPACK FOOTER //
// ./app/Alerts/email/sagas.js